import { client } from '../client';
import { IVideo } from '../communication/types/IVideo';
import { getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';

export const joinVideoRoom = async (caseId: number, userRole?: string): Promise<IVideo> => {
  const prefix = getStaffScopedApiPrefix(userRole);
  const { data } = await client.post<IVideo>(`${prefix}/cases/${caseId}/join_video_room`);

  return data;
};
